// error strings are not displayed
export const FIELD_VALIDATION_ERRORS = {
  FILES_TOO_LARGE: "files are too large",
  FILE_TOO_LARGE: "file is too large",
  UNSUPPORTED_EXTENSION: "unsupported file extension",
  ATTACHMENT_REQUIRED: "attachment required",
}

export const SUPPORTED_ATTACHMENTS = ["png", "jpg", "jpeg", "pdf"]

export const BYTES_IN_MEGABYTE = 1000000
